
export const LOGIN_URL =(clientId = 'berlin3') => `/EXT_LOGIN`;
export const EXT_LOGOUT =(clientId = 'berlin3') => `/EXT_LOGOUT`;
export const B2b_EXT = (clientId = 'berlin3') =>`/b2b.ext`;
export const LOGIN_EXT_PL = (clientId = 'berlin3') =>`/login.ext`;

